import React from 'react';
import {
  Flex,
  Heading,
  Button,
  Box,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaSync } from 'react-icons/fa';
import { OktonReactTable as Table } from '@okton/platform-ui/react-table';

import Page from '../../layout/IntegraAppPage';

const Usuarios = () => {
  const bgPage = useColorModeValue('white', 'gray.800');

  const usuariosData = [
    {
      Nome: 'Admin Sistema',
      Perfil: 'admin',
      Status: true,
      criadoEm: '23/12/2025',
    },
    {
      Nome: 'João Operador',
      Perfil: 'operador',
      Status: true,
      criadoEm: '22/01/2026',
    },
    {
      Nome: 'Maria Gerente',
      Perfil: 'gerente',
      Status: true,
      criadoEm: '06/02/2026',
    },
    {
      Nome: 'Pedro Operador',
      Perfil: 'operador',
      Status: false,
      criadoEm: '21/02/2026',
    },
  ];

  const colunasUsuario = React.useMemo(
    () => [
      {
        Header: 'NOME',
        accessor: 'Nome',
      },
      {
        Header: 'PERFIL',
        accessor: 'Perfil',
      },
      {
        Header: 'STATUS',
        accessor: 'Status',
      },
      {
        Header: 'CRIADO EM',
        accessor: 'criadoEm',
      },
    ],
    [],
  );

  return (
    <Page>
      <Flex justify="space-between" align="center" p={3}>
        <Heading fontWeight="bold" fontSize={25}>
          Usuários
        </Heading>

        <Button fontSize="15px" colorScheme="blue" leftIcon={<FaSync />}>
          Atualizar
        </Button>
      </Flex>

      <Box bg={bgPage} borderWidth="1px" borderRadius="md" p={4}>
        <Table columns={colunasUsuario} data={usuariosData} />
      </Box>
    </Page>
  );
};

export default Usuarios;
